import React from 'react';
import PropTypes from 'prop-types';

import Box from 'relements/build/esm/ui/box';

import reset from './Icon/reset.svg';

import {
  Container,
  Description,
  HighlightedText,
  SvgIcon,
} from './StyledComponents';

function SyncInfo({ channelName, isAutoPreview }) {
  return (
    <Container data-testid="SyncInfo" synced>
      <Box padding="zero">
        <SvgIcon src={reset} size="big" />
      </Box>
      <Box padding="zero" flexDirection="column">
        <Description variant="body.md" synced>
          Your&nbsp;
          <HighlightedText variant="h4.bold" synced>
            {channelName}
          </HighlightedText>
          &nbsp; bot responses are auto-synced with your &nbsp;
          <HighlightedText variant="h4.bold" synced>
            Web SDK
          </HighlightedText>
          &nbsp;responses.
        </Description>
        {isAutoPreview && (
          <Description variant="body.md" style={{ marginTop: '12px' }} synced>
            *Auto-preview-generation is not supported on this channel yet.
          </Description>
        )}
      </Box>
    </Container>
  );
}

SyncInfo.propTypes = {
  channelName: PropTypes.string,
  isAutoPreview: PropTypes.bool,
};

SyncInfo.defaultProps = {
  channelName: '',
  isAutoPreview: false,
};

export default React.memo(SyncInfo);
